

var React = require('react');
var Radium = require('radium');

let BodyBackground = (props) => (
  <div style={styles.img}/>
)

const styles = {
  img: {
    //https://css-tricks.com/perfect-full-page-background-image/
    /* Set rules to fill background */
    minHeight: '100%',
    minWidth: '1024px',
    zIndex: '-100',
    /* Set up proportionate scaling */
    width: '100%',
    height: 'auto',
    background: '#00c6ff',  /* fallback for old browsers */
    background: '-webkit-linear-gradient(to right, #00c6ff, #0072ff)',  /* Chrome 10-25, Safari 5.1-6 */
    background: 'linear-gradient(to right, #00c6ff, #0072ff)', /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */


    /* Set up positioning */
    position: 'fixed',
    top: '0',
    left: '0',
  }
}

BodyBackground = Radium(BodyBackground);

export default BodyBackground;



// WEBPACK FOOTER //
// ./src/comp/BodyBackground.js